import { cn } from '@/app/utils/style'

/**
 * Shared base classes for form input elements (input, textarea)
 */
export const inputBaseClasses = cn(
  'w-full rounded-lg lg:rounded-xl border-0 bg-neutral-50 transition-[color,border,box-shadow] duration-250',
  'px-2xl py-lg lg:px-3xl lg:py-xl',
  'size-input-md lg:size-input-lg font-medium text-neutral-900',
  'placeholder:text-neutral-500',
  'focus:outline-none focus:border-primary-600',
  'disabled:bg-neutral-200 disabled:text-neutral-400 disabled:cursor-not-allowed',
)

/**
 * Get box shadow classes based on error state
 */
export const getBoxShadowClasses = (error?: string) => {
  return error
    ? '[box-shadow:inset_0_0_0_2px_theme(colors.red.400)] focus:[box-shadow:inset_0_0_0_2px_theme(colors.red.400)] disabled:[box-shadow:inset_0_0_0_2px_theme(colors.neutral.400)]'
    : '[box-shadow:inset_0_0_0_2px_theme(colors.primary.50)] hover:[box-shadow:inset_0_0_0_2px_theme(colors.primary.200)] active:[box-shadow:inset_0_0_0_2px_theme(colors.primary.50)] disabled:[box-shadow:inset_0_0_0_2px_theme(colors.neutral.400)]'
}

/**
 * Shared label classes for form inputs
 */
export const labelClasses = 'size-input-sm lg:size-input-md ml-sm font-medium text-neutral-600'

/**
 * Shared error message classes
 */
export const errorClasses = 'size-input-sm lg:size-input-md ml-sm font-medium text-red-500'

/**
 * Shared helper text classes
 */
export const helperClasses =
  'mt-sm size-input-sm lg:size-input-md ml-sm font-medium text-neutral-600'
